export class FetchStripePlansAction {
  static readonly type = '[Payment] Fetch Stripe Plans';
  constructor() {}
}
